// extracted by mini-css-extract-plugin
export default {"wrapper":"SatisfactionRating_wrapper__u448J","content":"SatisfactionRating_content__xfJSr","likeAnimation":"SatisfactionRating_likeAnimation__E6uoT"};